import React from "react";
import PageLayout from "../PageLayout/PageLayout";
import { LEGAL_INTRO, LEGAL_META, LEGAL_SECTIONS } from "./legalSections";
import "./LegalPage.css";

export default function LegalPage({ title }) {
  return (
    <div className="legal-page-wrap">
      <PageLayout fullBleed>
        <article className="legal-page">
          <div className="legal-page__inner">
            <p className="legal-page__badge">Legal</p>
            <h1 className="legal-page__title">{title}</h1>
            <p className="legal-page__meta">{LEGAL_META}</p>
            <p className="legal-page__intro">{LEGAL_INTRO}</p>

            <div className="legal-page__sections">
              {LEGAL_SECTIONS.map((section, index) => (
                <section key={section.title} className="legal-page__section">
                  <h2>
                    {index + 1}. {section.title}
                  </h2>
                  {section.lines ? (
                    section.lines.map((line) => <p key={line}>{line}</p>)
                  ) : section.isContact ? (
                    <h5 className="legal-page__contact">{section.body}</h5>
                  ) : (
                    <p>{section.body}</p>
                  )}
                </section>
              ))}
            </div>
          </div>
        </article>
      </PageLayout>
    </div>
  );
}
